import React from 'react';
import { Button, Col, Row } from 'rsuite';

const attributes = {
  'pa_equipment-type': 'Type',
  'pa_equipment-make': 'Make',
  'pa_equipment-model': 'Model',
  'pa_equipment-year': 'Year',
  'pa_equipment-serial-number': 'Serial Number',
  'pa_equipment-stock-number': 'Stock Number',
  'pa_equipment-location': 'Location',
};

export const DetailCard = ({ post_title, image, image_large, price, desc, url, ...other }) => (
  <Col md={24}>
    <a className="nh-detail" href={url}>
      <Row className="nh-detail-row">
        <Col md={12} className="nh-detail-c1">
          <img className="nh-detail-image" alt={post_title} src={image_large}></img>
        </Col>
        <Col md={12} className="nh-detail-c2">
          <div className="nh-detail-body">
            <div className="nh-detail-name">{post_title}</div>
            <div className="nh-detail-desc" dangerouslySetInnerHTML={{ __html: desc }}></div>
            <div className="nh-detail-centering">
              <ul className="nh-detail-attrs">
                {Object.keys(attributes).map((attribute) => {
                  if (other[attribute]) {
                    return (
                      <li key={attribute}>
                        <div className="nh-detail-label">{attributes[attribute]}:</div>{' '}
                        {other[attribute]}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>

              <div className="nh-detail-price" dangerouslySetInnerHTML={{ __html: price }} />
              <div className="nh-detail-stretch" />
              <Button>Read More</Button>
            </div>
          </div>
        </Col>
        {/* <Col md={4} className="nh-detail-c3">
          <div
            className="nh-detail-price"
            dangerouslySetInnerHTML={{ __html: price }}
          />
          <div className="nh-detail-stretch" />
          <Button>Read More</Button>
        </Col> */}
      </Row>
    </a>
  </Col>
);
